import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  getDashboardSystemProblems,
  queryKeys,
  SystemProblemCategory,
} from '@vgrubs/components';

/**
 * The Dashboard card for one category chip (`null` is All): the counts over
 * every open problem, and the most urgent open ones of that category.
 *
 * Fetched when the Orders tab opens and refetched by
 * `useSystemProblemsSocket` on every event - the server orders by severity,
 * so a new problem's place on the card is not something to guess. The last
 * answer stays on screen while another chip loads, so the counters do not
 * blink.
 */
export const useDashboardSystemProblems = (
  category: SystemProblemCategory | null
) => {
  const query = useQuery({
    queryKey: queryKeys.systemProblems.dashboardFor(category),
    queryFn: async () => {
      const { data } = await getDashboardSystemProblems({ category });
      return data.data;
    },
    placeholderData: keepPreviousData,
  });

  return {
    open: query.data?.open ?? 0,
    bySeverity: query.data?.bySeverity,
    byCategory: query.data?.byCategory,
    items: query.data?.items ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
